"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const comparison_operator_value_1 = require("../../comparison-operator.value");
exports.appVersionCondition = {
    id: 'app-version',
    category: 'conditions',
    value: {
        versionValues: [],
        operatorValues: [
            { value: comparison_operator_value_1.ComparisonOperators.MATCH_EQUALS, label: 'CONDITION_SELECT_EXACTLY' },
            { value: comparison_operator_value_1.ComparisonOperators.MATCH_NOT_EQUALS, label: 'CONDITION_SELECT_IS_NOT' },
            { value: comparison_operator_value_1.ComparisonOperators.MATCH_GT, label: 'CONDITION_SELECT_MORE_THAN' },
            { value: comparison_operator_value_1.ComparisonOperators.MATCH_LT, label: 'CONDITION_SELECT_LESS_THAN' },
            { value: comparison_operator_value_1.ComparisonOperators.MATCH_GTE, label: 'CONDITION_SELECT_GREATER_OR_EQUAL' },
            { value: comparison_operator_value_1.ComparisonOperators.MATCH_LTE, label: 'CONDITION_SELECT_LESS_OR_EQUAL' },
        ],
    },
};
//# sourceMappingURL=app-version-condition.value.js.map